import Head from "next/head";
import { useRouter } from "next/router";

import type { ResolvedMeta, ResolvedMetaRobotAttribute } from "resolvers/data/metaResolver";
import cmsImageLoader, { srcIsCmsAsset } from "utils/cmsImageLoader";

const Meta = (props: ResolvedMeta) => {
    const { description, image, title, robotAttrs, url, type } = props;

    const isCmsAsset = srcIsCmsAsset(image);

    const s3Image = isCmsAsset ? cmsImageLoader({ width: 1200, src: image, quality: 75 }) : image;
    const s3SmallImage = isCmsAsset
        ? cmsImageLoader({ width: 400, src: image, quality: 75 })
        : image;

    const router = useRouter();
    const { page } = router?.query;
    const pageTitle = `${title}${
        page && Number.isInteger(+page) ? ` | Page ${page}` : ""
    } | Motorpoint`;

    return (
        <Head>
            <title>{pageTitle}</title>
            <meta name="description" content={description} />
            <meta property="og:description" content={description} />
            {s3Image && <meta property="og:image" content={s3Image} />}
            {s3SmallImage && <meta property="og:image" content={s3SmallImage} />}
            {image && <meta property="og:image" content={image} />}
            <meta property="og:site_name" content="Motorpoint" />
            <meta property="og:title" content={pageTitle} />
            <meta property="og:url" content={url} />
            {type && <meta property="og:type" content={type} />}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:description" content={description} />
            {s3Image && <meta property="twitter:image" content={s3Image} />}
            {s3SmallImage && <meta property="twitter:image" content={s3SmallImage} />}
            {image && <meta property="twitter:image" content={image} />}
            <meta property="twitter:url" content={url} />
            <meta name="format-detection" content="telephone=no" />
            {robotAttrs?.length &&
                robotAttrs.map((item: ResolvedMetaRobotAttribute, index: number) => (
                    <meta key={index} name={item.name} content={item.content} />
                ))}
        </Head>
    );
};

export default Meta;
